import Promise from 'bluebird'
import _ from 'lodash'

const COMPANY_HEADERS = ['sector', 'geography', 'stage', 'status', 'name']

/**
 * Company {
 * _id: mongo id
 * name: company name
 * status: Active, Out of Business, etc
 * last_funding: Last round of funding
 * stage: Seed, Pre-Seed, Series A, etc
 * sector: company sector (Fintech, etc)
 * geography: location of headquarters (San Francisco, etc)
 * description: long-form description of company
 * logo_url: url of company logo
 * ucid: public-facing unique id of the company
 * }
 */

// #region State
const state = {
    server_data: [],
    local_cache: [],
    _write_timer: 0,
    _processing_cycle: false,
    seq: 0
}
// #endregion

// #region Getters
const getters = {
    companyData (state) {
        // need to merge local_cache with company data
        let retval = _.map(state.server_data, data => {
            let cached = _.reduce(state.local_cache, (memo,cache) => {
                if (cache.ucid == data.ucid) return cache
                return memo
            }, {})
            // return all properties that don't start with '_'
            return _.omitBy(_.assign(data, cached), function(v,k) {return _.startsWith(k, '_')})
        })
        return retval
    },
    companyDataFull (state) {
      // need to merge local_cache with company data
      let retval = _.map(state.server_data, data => {
          let cached = _.reduce(state.local_cache, (memo,cache) => {
              if (cache.ucid == data.ucid) return cache
              return memo
          }, {})
          // return all properties that don't start with '_'
          return _.assign(data, cached)
      })
      return retval
    }
}
// #endregion

// #region Mutators
const mutations = {
    initialize (state) {
        state.server_data = []
        state.local_cache = []
        state._write_timer = 0
        state._processing_cycle = false,
        state.seq = 0
    },
    company (state, payload) {
        state.server_data = payload.server_data
    },
    merge (state, payload) {
        payload = payload.companies
        if (!_.isArray(payload)) payload = [payload]
        // assign ucid if they don't have one
        payload = _.map(payload, item => {
          if (_.isNil(item.ucid)) item.ucid = state.seq++
          return item
        })
        // merge what was returned from the server with what we have in server
        state.server_data = _.without(_.map(state.server_data, data => {
            if (!data) return data
            let index = _.findIndex(payload, function(p) {return p.ucid == data.ucid})
            if (index >= 0) {
                let item = _.first(_.pullAt(payload, index))
                if (_.lte(item.__v, data.__v)) return data
                return _.omit(_.merge(data, item), ['_sent', '_dirty'])
            }
            return data
        }),null,undefined)
        // add remaining updates
        state.server_data = _.concat(state.server_data, payload)
    },
    update (state, payload) {
        // go through the companies and merge any data
        let companies = payload.companies
        if (!_.isArray(companies)) companies = [companies]
        // assign ucid if they don't have one
        companies = _.map(companies, item => {
          if (_.isNil(item.ucid)) item.ucid = state.seq++
          return item
        })
        // remove any non-company data
        companies = _.map(companies, item => {
            item = _.omitBy(item, function(v,k) {return _.indexOf(COMPANY_HEADERS, k) < 0})
            if (_.keys(item).length < 2) return null
            return item
        })
        companies = _.without(companies, null, undefined)
        if (companies.length < 1) return // ignore any updates not pertinent to this collection
        // get our _id for the company
        let update = _.without(_.map(payload, item => {
            let company = _.find(state.server_data, function(d) {return d.name == item.name})
            if (company) return _.assign({}, item)
        }), undefined, null)
        if (!_.isEmpty(update)) {
            state.local_cache = _.map(state.local_cache, cached => {
                let index = _.findIndex(update, function(u) {return u.ucid == cached.ucid})
                if (index >= 0) {
                    let cpny = _.first(_.pullAt(update, index))
                    return _.merge(cached, cpny, {_dirty: Date.now()})
                }
                return cached
            })
            // add remaining updates, that were not merged
            state.local_cache = _.concat(state.local_cache, update)
        }
    },
    clean (state, payload) {
        // payload is data written to the server
        // remove any data older than _sent from the local cache
        state.local_cache = _.without(_.map(state.local_cache, cached => {
            let item = _.find(payload, function(p) {return p.ucid == cached.ucid})
            if (!item || item._sent < cached._dirty) return cached // return only if dont have it in the payload or it is newer
        }), undefined, null)
    },
}
// #endregion

// #region Actions
const actions = {
    start ({}) {},
    stop ({commit}) {
        // clean up
        commit('initialize')
    },
    cycle () {},
    apiPatchCompany ({state}) {
      return Promise.resolve({})
    }
}
// #endregion

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}